








































































































































import Component from "vue-class-component";
import BaseComponent from "../../../../components/shared/BaseComponent.vue";
import ConfirmModal from "@/components/shared/modals/ConfirmModal.vue";
import ErrorModal from "@/components/shared/modals/NewErrorModal.vue";
import Modal from "@/components/shared/modals/Modal.vue";
import Plans from "@/components/marketing/Plans.vue";
import { Card, createToken } from "vue-stripe-elements-plus";
import CurrencyToggle from "@/components/marketing/toggles/CurrencyToggle.vue";
import InvoiceToggle from "@/components/marketing/toggles/InvoiceToggle.vue";
import { SubscriptionProductDto } from "@/application/dtos/master/subscriptions/SubscriptionProductDto";
import { SubscriptionPriceDto } from "@/application/dtos/master/subscriptions/SubscriptionPriceDto";
import { TenantCreateRequest } from "@/application/contracts/master/tenants/TenantCreateRequest";
import ConfirmModalComponent from "@/components/shared/modals/ConfirmModal.vue";
import { SubscriptionBillingPeriod } from "@/application/enums/master/subscriptions/SubscriptionBillingPeriod";
import services from "@/services";

@Component({
  components: {
    ErrorModal,
    Modal,
    ConfirmModal,
    Plans,
    Card,
    CurrencyToggle,
    InvoiceToggle
  }
})
export default class TenantNew extends BaseComponent {
  $refs!: {
    errorModal: ErrorModal;
    cardModal: Modal;
    confirmModal: ConfirmModalComponent;
  };
  private name: string = "";
  private stripeKey: string = "";
  private stripeOptions: any = {};
  private complete: boolean = false;
  created() {
    this.stripeKey =
      process.env.VUE_APP_SUBSCRIPTION_PUBLIC_KEY?.toString() ?? "";
    this.stripeOptions = {
      showCardHolderName: true,
      hidePostalCode: false,
      iconStyle: "solid",
      elements: {
        locale: this.$i18n.locale
      }
    };
    if (!this.selectedProduct) {
      this.$store.commit("pricing/select", {
        product: this.$store.state.pricing.products[0],
        billingPeriod: SubscriptionBillingPeriod.MONTHLY
      });
    }
  }
  mounted() {
    services.subscriptionProducts.getProducts(true, true);
  }
  close() {
    this.$emit("close");
  }
  createTenant() {
    if (!this.selectedPrice) {
      this.$refs.errorModal.show("Selecciona un plan");
    } else if (this.name === "") {
      this.$refs.errorModal.show("Escribe un nombre");
    } else {
      this.$refs.confirmModal.show(this.$t("settings.tenant.createConfirm"));
    }
  }
  tryRegister() {
    if (this.selectedPrice?.trialDays === 0 && this.selectedPrice?.price > 0) {
      this.$refs.cardModal.show(
        this.$t("account.register.providePaymentDetails").toString(),
        this.$t("shared.cancel")
      );
    } else {
      this.register();
    }
  }
  pay() {
    createToken()
      .then(data => {
        if (data.error) {
          this.$refs.errorModal.show(data.error.message);
        } else {
          this.register(data.token.id);
        }
      })
      .catch(error => {
        this.$refs.errorModal.show(error);
      })
      .finally(() => {
        this.$refs.cardModal.close();
      });
  }
  register(stripeCardToken: string = "") {
    const tenantCreateRequest: TenantCreateRequest = {
      name: this.name,
      selectedSubscription: {
        subscriptionPriceId: this.selectedPrice?.id ?? "",
        subscriptionCardToken: stripeCardToken,
        subscriptionCoupon: ""
      }
    };
    services.tenants
      .create(tenantCreateRequest)
      .then(response => {
        this.name = "";
        this.$router.go(0);
      })
      .catch(error => {
        this.$refs.errorModal.show(error);
      });
  }
  get selectedProduct() {
    return this.$store.state.pricing.selectedProduct as SubscriptionProductDto;
  }
  get getButtonText() {
    if (this.selectedPrice) {
      return (
        (this.selectedPrice.billingPeriod === SubscriptionBillingPeriod.ONCE
          ? this.$t("marketing.pricing.pay")
          : this.$t("marketing.pricing.subscribe")) +
        " " +
        this.priceDescription
      );
    }
  }
  get selectedPrice(): SubscriptionPriceDto | undefined {
    if (this.selectedProduct) {
      return (
        this.selectedProduct.prices.find(
          f => f.billingPeriod === this.$store.state.pricing.billingPeriod
        ) ?? this.selectedProduct.prices[0]
      );
    }
  }
  get billingPeriod() {
    if (this.selectedPrice) {
      if (
        this.selectedPrice?.billingPeriod === SubscriptionBillingPeriod.ONCE
      ) {
        return this.$t("marketing.pricing.once");
      } else {
        return (
          "/ " +
          this.$t(
            "marketing.pricing." +
              SubscriptionBillingPeriod[this.selectedPrice.billingPeriod] +
              "Short"
          )
        );
      }
    }
  }
  get priceDescription() {
    return "$" + this.selectedPrice?.price + " " + this.billingPeriod;
  }
}
